import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {Text} from '../../../../../uikit/Text';
import {View} from '../../../../../uikit/View';
import {isDefined} from '../../../../../utils/typecheck';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, membership, program} = contexts;
  const {created_by_id, decline} = membership ?? {};

  // created_by isn't defined for old memberships, so we need to check it
  const isMembershipCreatedByClient =
    isDefined(created_by_id) && created_by_id !== actor?._id;

  const translatePath = isMembershipCreatedByClient
    ? 'created_by_client'
    : 'created_by_coach';

  /**
   * @i18n_parser
   *
   * t('notifications:membership_declined.title.created_by_client')
   * t('notifications:membership_declined.title.created_by_coach')
   */
  const title = i18n.t(
    `notifications:membership_declined.title.${translatePath}`,
    {
      actorName: actor?.name,
      programTitle: program?.title,
    },
  );

  const {reason} = decline ?? {};
  const renderMessage = reason
    ? () => (
        <View style={{display: 'flex', flexDirection: 'column'}}>
          <Text variant="label.la" weight="semibold">
            {`${i18n.t('shared:reason')}:`}
          </Text>
          <Text variant="label.la">{reason}</Text>
        </View>
      )
    : undefined;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    renderMessage,
    subAvatar: actor?.avatar,
    subAvatarPlaceholder: actor?.name,
    title,
  };
};
